var map = {
	"./anamensi.svg": 61764,
	"./cuore.svg": 55871,
	"./esame_obiettivo.svg": 21744,
	"./logo.png": 43916,
	"./runner.svg": 29032,
	"./stomaco.svg": 21532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43836;